import React, {useState, useEffect, useRef} from 'react';

const NavItem = (props) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null)

        // close on clicking off the dropdown
        useEffect(() =>{
            ["click", "touchend"].forEach(e => {
              document.addEventListener(e, closeOnClickOff)
            })
            
            return () => ["click", "touchend"].forEach(e => {
              document.removeEventListener(e, closeOnClickOff)
            })
          }, []);

    function closeOnClickOff(e){
        if (e.target.nodeName!="A" && e.target.nodeName != "svg" && e.target.nodeName != "path") setOpen(false)
      }

    const handleOnClick = (e) =>{
        setOpen(!open)
        closeOnClickOff(e)
    }

    return (
        <li className="nav-item unselectable" ref={ref} >
            <a href={props.link} target={props.target} className="icon-button" onClick={handleOnClick}> 
                {props.icon}
            </a>

            {open && props.children}
        </li>
    )
}

export default NavItem
